import dayjs from "dayjs";
import React, { useContext, useState } from "react";
import logo from "../assets/logo.png";
import GlobalContext from "../context/GlobalContext";
import { getMes } from "../util";
import DatePicker from "react-datepicker";
import Switch from "react-switch";

export default function CalendarHeader() {
  const { monthIndex, setMonthIndex } = useContext(GlobalContext);
  const { tipoFiltro, setTipoFiltro } = useContext(GlobalContext);
  const [tipoFiltroLocal, setTipoFiltroLocal] = useState(0);
  const { dtInicial, setDtInicial } = useContext(GlobalContext);
  const { dtFinal, setDtFinal } = useContext(GlobalContext);

  const [dtInicialLocal, setDtInicialLocal] = useState(dtInicial);
  const [dtFinalLocal, setDtFinalLocal] = useState(dtFinal);

  const [filtrarTiposCompromisso, setFiltrarTiposCompromisso] =
    useState(false);

  const [savedEventsBkp, setSavedEventsBkp] = useState([]);

  const { savedEvents, dispatchCalEvent } = useContext(GlobalContext);

  function handlePrevMonth() {
    setMonthIndex(monthIndex - 1);
  }
  function handleNextMonth() {
    setMonthIndex(monthIndex + 1);
  }
  function handleReset() {
    setMonthIndex(
      monthIndex === dayjs().month()
        ? monthIndex + Math.random()
        : dayjs().month()
    );
  }
  function filtrar() {
    if(tipoFiltroLocal === 4){
      if (dtInicialLocal.isAfter(dtFinalLocal)) {
        alert("Data inicial deve ser menor que a data final!");
        return false;
      }
    }
    setDtInicial(dtInicialLocal);
    setDtFinal(dtFinalLocal);
    setTipoFiltro(tipoFiltroLocal);
  }

  function filtrarCompromissos(isChecked) {
    let listaTipoCompromissos = [
      "264f9e189b3297f77f48ac63e81c0346",
      "264f9e189b3297f77f48ac63e81c5ce3",
      "55605cd248a9be824f0228922ff0e739",
      "55605cd248a9be824f0228922ff0ba48",
    ];

    if (savedEventsBkp.length === 0) {
      setSavedEventsBkp(savedEvents);
    }

    if (isChecked) {
      let savedEventsLocal = savedEvents.filter(
        (it) =>
          it.tipoCompromisso !== null &&
          listaTipoCompromissos.includes(it.tipoCompromisso._id)
      );
      dispatchCalEvent({
        type: "atualiza",
        payload: savedEventsLocal,
      });
    } else {
      dispatchCalEvent({
        type: "atualiza",
        payload: savedEventsBkp,
      });
    }
  }

  return (
    <header
      className="px-4 py-2 flex items-center"
      style={{ position: "relative" }}
    >
      {/* <img src={logo} alt="calendar" className="mr-2 w-12 h-12" />
      <h1 className="mr-10 text-xl text-gray-500 fond-bold">
        Agenda
      </h1> */}

      {/* <button
        onClick={handleReset}
        className="border rounded py-2 px-4 mr-5"
      >
        Hoje
      </button> */}

      <div>
        <select
          className="pt-3 border-0 text-gray-600 text-xl font-semibold pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500"
          value={tipoFiltroLocal}
          onChange={(e) =>
            setTipoFiltroLocal(parseInt(e.target.value))
          }
        >
          <option value={0}>Mensal</option>
          <option value={1}>Próximos 7 Dias</option>
          <option value={2}>Próximos 14 Dias</option>
          <option value={3}>Próximos 30 Dias</option>
          <option value={4}>Personalizado</option>
        </select>
      </div>

      {tipoFiltroLocal === 4 && (
        <React.Fragment>
          <div style={{ marginLeft: "8px", width: "150px" }}>
            <DatePicker
              selected={dtInicialLocal.toDate()}
              withPortal
              customInput={
                <input className="pt-3 border-0 text-gray-600 text-xl font-semibold pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500 text-center" />
              }
              dateFormat="dd/MM/yyyy"
              onChange={(value) => setDtInicialLocal(dayjs(value))}
              locale="pt-BR"
            />
          </div>
          à
          <div style={{ marginLeft: "8px", width: "150px" }}>
            <DatePicker
              selected={dtFinalLocal.toDate()}
              withPortal
              customInput={
                <input className="pt-3 border-0 text-gray-600 text-xl font-semibold pb-2 w-full border-b-2 border-gray-200 focus:outline-none focus:ring-0 focus:border-blue-500 text-center" />
              }
              dateFormat="dd/MM/yyyy"
              onChange={(value) => setDtFinalLocal(dayjs(value))}
              locale="pt-BR"
            />
          </div>
        </React.Fragment>
      )}

      <div style={{ marginLeft: "20px" }}>
        <button
          className="bg-gray-300 text-gray-800 border border-gray-400 hover:bg-gray-400 font-semibold py-2 px-4 rounded"
          style={{ backgroundColor: "#6c757d" }}
          onClick={() => filtrar()}
        >
          <i className="fa fa-filter" style={{ color: "#FFF" }}></i>
        </button>
      </div>

      {tipoFiltroLocal === 0 && (
        <div className="flex" style={{ marginLeft: "20px" }}>
          <h2 className="text-xl text-gray-500 font-bold">
            {getMes(
              dayjs(new Date(dayjs().year(), monthIndex)).format("MM")
            )}
            &nbsp;
            {dayjs(new Date(dayjs().year(), monthIndex)).format(
              "YYYY"
            )}
          </h2>

          <button onClick={handlePrevMonth}>
            <span className="material-icons-outlined cursor-pointer text-gray-600 mx-2">
              chevron_left
            </span>
          </button>
          <button onClick={handleNextMonth}>
            <span className="material-icons-outlined cursor-pointer text-gray-600 mx-2">
              chevron_right
            </span>
          </button>
        </div>
      )}

      <div
        className="item-switch"
        style={{
          display: "flex",
          position: "absolute",
          right: "10px",
        }}
      >
        <span style={{ marginRight: "15px" }}>Agenda Escalador ?</span>
        <Switch
          checked={filtrarTiposCompromisso}
          onChange={(isChecked) => {
            setFiltrarTiposCompromisso(isChecked);
            filtrarCompromissos(isChecked);
          }}
          onColor="#8c9a9a"
          onHandleColor="#244973"
          handleDiameter={22}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={15}
          width={45}
        />
      </div>
    </header>
  );
}
